import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Grid, Typography } from '@kc-console/common-ui';
import { useScopedLinkBuilder } from '@kc-console/context';
import { SpriteImgIcon } from '@kc-console/shared-ui';
import { IcArrowEnterRegular } from '@kep/kcds-icons';

import { useMegaMenuState } from '../../../../hooks';
import ColorKeywordText from '../../Gnb/Search/ColorKeywordText';

import type { TokenScope } from '@kc-console/context';

interface Props {
  keyword: string;
  menu: {
    category: string;
    name: string;
    path: string;
    scope: TokenScope;
    serviceKeyword: string;
  };
}

const SearchResultMenuItem = ({ menu, keyword }: Props) => {
  const { name, category, serviceKeyword, path } = menu;
  const { setIsOpen } = useMegaMenuState();
  const { getProps } = useScopedLinkBuilder();

  return (
    <li>
      <StyledMenuItemAnchor {...getProps(path, { onClick: () => setIsOpen(false) })}>
        <MenuItemLeftContainer>
          <SpriteImgIcon fontSize={24} id={serviceKeyword} category={'BeyondServiceRegular'} />
          <StyledServiceInfo>
            <Grid container alignItems={'center'}>
              <ColorKeywordText text={name} keyword={keyword} />
            </Grid>
            <ServiceDescription variant={'body/normal/xs'}>{category}</ServiceDescription>
          </StyledServiceInfo>
        </MenuItemLeftContainer>
        <div id="enter-icon">
          <IcArrowEnterRegular />
        </div>
      </StyledMenuItemAnchor>
    </li>
  );
};

const menuItemContainerStyles = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: inherit;
  padding: 6px 24px 6px 12px;

  #enter-icon {
    display: none;
  }

  &:hover {
    background-color: #f9fafb;
  }

  &:active {
    background-color: #f6f7f9;
  }

  &:hover,
  &:active {
    #enter-icon {
      display: block;
    }
  }

  &:focus-visible {
    background-color: transparent;
    outline: 2px solid #000;
    outline-offset: -2px;
  }
`;

const StyledMenuItemAnchor = styled('a')`
  ${menuItemContainerStyles}
`;

const MenuItemLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledServiceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 12px;
`;

const ServiceDescription = styled(Typography)`
  font-size: 12px;
  color: #676f7d;
  line-height: 18px;
`;

export default SearchResultMenuItem;
